import { title, container } from "assets/jss/material-kit-react.js";

const productStyle = {
  rootContainer: {
    textAlign: "center",
    backgroundColor: "black",
    color: "white",
  },
  section: {
    minHeight: "100vh",
    padding: "5px 0",
    textAlign: "center",
    backgroundColor: "clear",
    color: "white",
    position: "relative",
    zIndex: "2",
  },
  imgContainer: {
    width: "100%",
    height: "100vh",
    backgroundImage:
      "linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.5)),url(" +
      require("assets/img/barn.jpg") +
      ")",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    position: "absolute",
    zIndex: "1",
    opacity: "0.2",
  },
  bubbleSectionTitle: {
    color: "white",
    fontSize: "32px",
    fontWeight: "400",
    textAlign: "left",
    paddingInline: "24px",
    fontFamily: `"Roboto Slab", "Times New Roman", serif`,
    "@media (min-width: 400px)": {
      fontSize: "34px",
      textAlign: "left",
      paddingInline: "52px",
    },
    "@media (min-width: 960px)": {
      fontSize: "40px",
      textAlign: "center",
      paddingInline: "48px",
    },
  },
  container,
  card: {
    width: "500px",
    backgroundColor: "white",
    borderRadius: "1em",
    margin: "30px",
    padding: "1em",
    textAlign: "left",
    display: "flex",
    flexDirection: "column",
  },
  title: {
    ...title,
    marginBottom: "1rem",
    marginTop: "30px",
    minHeight: "32px",
    textDecoration: "none",
  },
  description: {
    color: "#999",
  },
  titleContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  checkboxContainer: {
    display: "flex",
    alignItems: "center",
  },
  marginRight: {
    marginRight: "7px",
  },
  sendButton: {
    border: "1px solid black",
    alignSelf: "center",
  },
  inputContainer: {
    display: "flex",
  },
  scrollButton: {
    position: "sticky",
    float: "right",
    bottom: "0",
    zIndex: "999",
  },
};

export default productStyle;
